import { SelectedFile } from "../../types/PostSelection";
import { getSelectedFileKey } from "./resolvePostMediaSelections";

export function getSelectedMediaIds(
  enhancedImgs: { postMediaId: number; selectionKey: string }[],
  selected: SelectedFile[]
) {
  if (!selected) {
    return null;
  }

  const selectedMediaIds: number[] = [];

  for (const img of selected) {
    const selectionKey = getSelectedFileKey(img);
    const file = enhancedImgs.find((e) => e.selectionKey === selectionKey);
    if (file) {
      selectedMediaIds.push(file.postMediaId);
    }
  }

  return selectedMediaIds;
}
